var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0C2.34315 0 1 1.34315 1 3V13C1 14.6569 2.34315 16 4 16H10C10.5523 16 11 15.5523 11 15C11 14.4477 10.5523 14 10 14H4C3.44772 14 3 13.5523 3 13V3C3 2.44772 3.44772 2 4 2H10C10.5523 2 11 1.55228 11 1C11 0.447715 10.5523 0 10 0H4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2929 11.7071C9.90237 11.3166 9.90237 10.6834 10.2929 10.2929L11.5858 9H6C5.44772 9 5 8.55229 5 8C5 7.44772 5.44771 7 6 7L11.5858 7L10.2929 5.70711C9.90237 5.31658 9.90237 4.68342 10.2929 4.29289C10.6834 3.90237 11.3166 3.90237 11.7071 4.29289L14.7071 7.29289C14.8946 7.48043 15 7.73478 15 8C15 8.26522 14.8946 8.51957 14.7071 8.70711L11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071Z",
    fill: "currentColor"
  })));
}

export default SvgLogout;